import React, { useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // EmailJS Configuration - Get from environment variables
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    // Check if credentials are configured
    if (!serviceId || !templateId || !publicKey ||
        serviceId === 'your_service_id_here' ||
        templateId === 'your_template_id_here' ||
        publicKey === 'your_public_key_here') {
      alert('⚠️ EmailJS not configured properly.\n\nPlease:\n1. Sign up at https://www.emailjs.com/\n2. Create a service (Gmail/Outlook)\n3. Create an email template\n4. Update the .env file with your actual credentials\n\nThen restart the development server.');
      return;
    }

    // Show loading state
    const submitButton = document.querySelector('.contact-form button');
    const originalText = submitButton.textContent;
    submitButton.textContent = 'Sending...';
    submitButton.disabled = true;

    emailjs.send(
      serviceId,
      templateId,
      {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
        to_email: 'surajshah0915@gmail.com',
        reply_to: formData.email
      },
      publicKey
    )
    .then((result) => {
      console.log('Email sent successfully:', result);
      alert('✅ Message sent successfully! I will get back to you soon.');
      setFormData({ name: '', email: '', message: '' });
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }, (error) => {
      console.error('Email send failed:', error);
      submitButton.textContent = originalText;
      submitButton.disabled = false;
      alert('❌ Failed to send message (EmailJS error). Please verify Service ID, Template ID, Public Key, and template variables, or contact directly at surajshah0915@gmail.com');
    });
  };

  return (
    <motion.div
      className="contact"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <h2>Contact Me</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>Get In Touch</h3>
            <p>I'm always open to discussing new opportunities and interesting projects.</p>
            <div className="contact-details">
              <p><strong>Email:</strong> surajshah0915@gmail.com</p>
              <p><strong>Phone/WhatsApp:</strong> +977 9844511713</p>
              <p><strong>Location:</strong> Nepal 🇳🇵</p>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="contact-form">
            <motion.input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              whileFocus={{ scale: 1.02 }}
            />
            <motion.input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              whileFocus={{ scale: 1.02 }}
            />
            <motion.textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
              whileFocus={{ scale: 1.02 }}
            ></motion.textarea>
            <motion.button
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Send Message
            </motion.button>
          </form>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;